import { render, staticRenderFns } from "./VFormLabel.vue?vue&type=template&id=1f4ccd9b&scoped=true&"
import script from "./VFormLabel.vue?vue&type=script&lang=js&"
export * from "./VFormLabel.vue?vue&type=script&lang=js&"
import style0 from "./VFormLabel.vue?vue&type=style&index=0&id=1f4ccd9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4ccd9b",
  null
  
)

export default component.exports